export default __webpack_public_path__ + "static/media/SWT1040.34I-40575_-23992_0.b54b80ed.jpg";